module.exports = __webpack_public_path__ + "media/images/phone-hand-644d981016a7e1a6d0756bd6ace36b20.svg";